import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "roundCss" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hmd_round = _resolveComponent("hmd-round")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.value === '尚未往来')
        ? (_openBlock(), _createBlock(_component_hmd_round, {
            key: 0,
            type: "nothave"
          }))
        : _createCommentVNode("", true),
      (_ctx.value === '正在往来')
        ? (_openBlock(), _createBlock(_component_hmd_round, {
            key: 1,
            type: "having"
          }))
        : _createCommentVNode("", true),
      (_ctx.value === '曾经往来')
        ? (_openBlock(), _createBlock(_component_hmd_round, {
            key: 2,
            type: "once"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, _toDisplayString(_ctx.value), 1)
    ])
  ]))
}